<template>
  <div id="app">
      <support></support>
    	<Head></Head>
    	<keep-alive>
      		<router-view ></router-view>
    	</keep-alive>
		<Foot></Foot>
  </div>
</template>

<script>
import Head from "base/head";
import Foot from "base/foot";
import support from "base/support";
import { mapActions, mapState } from "vuex";
import "babel-polyfill";
export default {
  components: {
    Head,
    Foot,
    // Foot: () => import("base/foot"),
    support
  },
  mounted() {
    this.SET_SHOW();
  },
  methods: {
    ...mapActions(["SET_SHOW"])
  },
  computed: {
    ...mapState(["show"])
  }
};
</script>
<style>
</style>






// WEBPACK FOOTER //
// src/App.vue